<section class="py-4">

  <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div *ngIf="tableLoading" class="p-5 d-flex justify-content-center position-relative">
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">

    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th width="30%">Configuração</th>
            <th width="30%">Cliente</th>
            <th width="30%">Tipo laudo</th>
            <th class="text-right" *ngIf="usuario.permissoes.administrador || usuario.permissoes.usuario_analista">
              <span data-toggle="tooltip" data-placement="bottom" title="Adicionar">
              <a [routerLink]="['/laudo', 'configuracao', 'adicionar']" class="btn btn-sm btn-success btn-icon">
                <i class="mdi mdi-plus"></i>
                <span>Adicionar</span>
              </a>
            </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="listaResultado.length==0">
            <td class="text-center py-5 text-secondary w-500" colspan="4">
              Sem registros
            </td>
          </tr>
          <tr *ngFor="let r of listaResultado">
            <td>{{r.id}}</td>
            <td>{{r.nomeConfig}}</td>
            <td>{{r.nomeCliente || 'AVULSO'}}</td>
            <td>{{r.nomeTipoLaudo}}</td>
            <td class="py-1" *ngIf="usuario.permissoes.administrador || usuario.permissoes.usuario_analista">
              <div class="d-flex align-items-center justify-content-end">
                <span data-toggle="tooltip" data-placement="bottom" title="Editar">
                <a [routerLink]="['/laudo','configuracao','editar',r.uuid]" class="btn btn-sm btn-primary btn-icon mr-1">
                  <i class="mdi mdi-pencil"></i>
                </a>
              </span>
                <button (click)="delete(r)" class="btn btn-sm btn-danger btn-icon">
                  <i class="mdi mdi-delete"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer bg-white row justify-content-between">
      <div class="pb-2 pb-sm-0">
        <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total"
          [(page)]="params.page" (pageChange)="pageChange()" [maxSize]="5" [rotate]="true">
        </ngb-pagination>
      </div>
      <div class="pb-2 pb-sm-0">
        <div class="btn-group" role="group">
          <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}"
            type="button" class="btn btn-outline-primary">10</button>
          <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}"
            type="button" class="btn btn-outline-primary">25</button>
          <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}"
            type="button" class="btn btn-outline-primary">50</button>
          <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}"
            type="button" class="btn btn-outline-primary">100</button>
        </div>
      </div>
    </div>
  </div>

</section>
